/*
 * Postscript 15% popup — Add-to-cart trigger (A/B treatment)
 * -----------------------------------------------------------
 * Fires the Postscript popup when a visitor adds to cart, as the treatment
 * arm of the "idle-timer vs add-to-cart" popup test. Scaffolded off the
 * existing "Take 15% Off" trigger in product-info.js and the theme's Dawn
 * pub/sub system (constants.js + pubsub.js), so it uses the theme's own
 * add-to-cart event rather than watching network requests.
 *
 * Toggle off: remove the <script> tag for this file in layout/theme.liquid
 * (or delete this file). Nothing else depends on it.
 *
 * VERIFY IN POSTSCRIPT: because respectPopupStatus:false force-opens, confirm
 * Postscript only shows this popup to visitors it assigned to the ATC test
 * group. If it does not gate by group, the split must move in-theme instead.
 */
(function () {
  var POPUP_ID = 'fb5616f7-2e86-4e6c-affe-fd5d8d57daef';

  // Which cartUpdate sources count as a real "add to cart" (not cart qty edits).
  var ADD_SOURCES = ['product-form', 'quick-add'];

  // Fire only once per session so repeat adds don't nag the shopper.
  // Set to false to fire on every add-to-cart.
  var ONCE_PER_SESSION = true;
  var SESSION_KEY = 'ps_atc_popup_fired';

  function alreadyFired() {
    if (!ONCE_PER_SESSION) return false;
    try {
      return sessionStorage.getItem(SESSION_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function markFired() {
    try {
      sessionStorage.setItem(SESSION_KEY, '1');
    } catch (e) {}
  }

  function openPopup() {
    if (!(window.postscript && window.postscript.popups)) return;
    if (alreadyFired()) return;
    markFired();
    window.postscript.popups.open(POPUP_ID, {
      activePopupBehavior: 'ALWAYS_DISMISS',
      respectPopupStatus: false,
    });
  }

  function init() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      var source = event && event.source;
      if (ADD_SOURCES.indexOf(source) === -1) return; // ignore cart qty changes, etc.
      // small delay so the cart drawer/update settles before the popup opens
      setTimeout(openPopup, 250);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
